import React, { JSX, useMemo, useState } from "react";
import "../../styles/AuthTriggerButton.scss";
import { AnimatePresence } from "framer-motion";
import { useUserContext } from "../../context/UserContext";
import { Authentication } from "./Authentication";
import { isMobile } from "react-device-detect";
import { useClubContext } from "../../context/ClubContext";
import { MemberIcon } from "../MemberIcon";
import { usePluginEvent } from "../../hooks/usePluginEvent";
import { PLUGIN_EVENTS } from "../../utils/pluginEvents";
import { CRM_TYPES } from "../../models/crm-types";
import { useLabelsContext } from "../../context/LabelsContext";
import { useAuthContext } from "../../context/AuthContext";
import { AUTH_STEPS } from "../../models/auth-steps";

const AuthTriggerButton: React.FC = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { club, personalAreaUrl } = useClubContext();
	const { labels } = useLabelsContext();
	const { otpMethod, setAuthStep } = useAuthContext();
	const {
		user,
		isLoading: loadingUser,
		onLogout,
		isLoggingOut,
	} = useUserContext();

	const toggleModal = () => setIsModalOpen(prev => !prev);

	usePluginEvent(PLUGIN_EVENTS.SHOW_LOGIN_POPUP, () => {
		setIsModalOpen(true);
	});

	const loggedInButton = useMemo((): JSX.Element => {
		if (isMobile) {
			return (
				<div className='d-flex gap-8 align-items-center'>
					{club?.cRMType === CRM_TYPES.OCTOPUS ? (
						<span className='d-flex gap-4 align-items-center ff-medium'>
							<MemberIcon />
							<span>{user?.Name}</span>
						</span>
					) : (
						<a className='club-button' href={personalAreaUrl}>
							<MemberIcon />
							<span>{user?.Name}</span>
						</a>
					)}

					{club?.cRMType === CRM_TYPES.OCTOPUS && (
						<button
							className='ff-medium'
							style={{
								background: "none",
								border: "none",
								textDecoration: "underline",
							}}
							onClick={() => {
								onLogout(otpMethod).then((success: boolean) => {
									success && setAuthStep(AUTH_STEPS.LOGIN);
								});
							}}
							disabled={isLoggingOut}
						>
							{isLoggingOut && (
								<span className='loader primary'></span>
							)}
							{labels?.["LogOut"]}
						</button>
					)}
				</div>
			);
		}

		// desktop: open authentication modal
		return (
			<button className='club-button' onClick={toggleModal}>
				<MemberIcon />
				<span>{user?.Name}</span>
			</button>
		);
	}, [user?.Name, personalAreaUrl]);

	const loggedOutButton = useMemo((): JSX.Element => {
		const clubLogoUrl = club?.clubLogoUrl;

		return (
			<button className='club-button' onClick={toggleModal}>
				<MemberIcon />
				{clubLogoUrl ? (
					<img src={clubLogoUrl} alt={club?.clubName} />
				) : (
					<span>{club?.clubName}</span>
				)}
			</button>
		);
	}, [club?.clubLogoUrl, club?.clubName]);

	if (loadingUser) return null;

	return (
		<div
			className={`club-button-wrapper ${user?.LoggedIn ? "logged-in" : ""}`}
		>
			{user?.LoggedIn ? loggedInButton : loggedOutButton}
			<AnimatePresence>
				{isModalOpen && (
					<Authentication setIsModalOpen={setIsModalOpen} />
				)}
			</AnimatePresence>
		</div>
	);
};
export default AuthTriggerButton;
